// Forms
import UIButton from './forms/Button.vue';
import UIInputText from './forms/InputText.vue';
import UITextarea from './forms/Textarea.vue';
import UIInputMask from './forms/InputMask.vue';
import UIDropdown from './forms/Dropdown.vue';
import UISlider from './forms/Slider.vue';

// Display
import UIBadge from './display/Badge.vue';

// Feedback
import UIMessage from './feedback/Message.vue';
import UIProgressSpinner from './feedback/ProgressSpinner.vue';
import UIToast from './feedback/Toast.vue';

// Data
import UIDataTable from './data/DataTable.vue';
import UIColumn from './data/Column.vue';

// Layout
import UIDialog from './layout/Dialog.vue';
import UIAccordion from './layout/Accordion.vue';
import UIAccordionTab from './layout/AccordionTab.vue';
import UIMenubar from './layout/Menubar.vue';

// Export all components
export { 
  UIButton, 
  UIInputText, 
  UITextarea, 
  UIInputMask,
  UIDropdown,
  UISlider,
  UIBadge, 
  UIMessage, 
  UIProgressSpinner,
  UIToast,
  UIDataTable,
  UIColumn,
  UIDialog,
  UIAccordion,
  UIAccordionTab,
  UIMenubar
};

// Export with simpler names for convenience
export const Button = UIButton;
export const InputText = UIInputText;
export const Textarea = UITextarea;
export const InputMask = UIInputMask;
export const Dropdown = UIDropdown;
export const Slider = UISlider;
export const Badge = UIBadge;
export const Message = UIMessage;
export const ProgressSpinner = UIProgressSpinner;
export const Toast = UIToast;
export const DataTable = UIDataTable;
export const Column = UIColumn;
export const Dialog = UIDialog;
export const Accordion = UIAccordion;
export const AccordionTab = UIAccordionTab;
export const Menubar = UIMenubar;

// Composables
export { useToast } from '@/composables/utils/useToast'; 